import React, { createContext, useReducer } from 'react';
import organizationSubscriptionReducer from './OrganizationSubscriptionReducer';

export const initialValue = {
    paymentMethods: [],
    invoices: [],
    customerInfo: {},
    billingInformation: {},
    taxInfo: {},
    selectedPaymentMethodId: "",
};

export const OrganizationSubscriptionContext = createContext(initialValue);

function OrganizationSubscriptionProvider({ children }) {

    const [state, dispatch] = useReducer(organizationSubscriptionReducer, initialValue);
    
    return (
        <OrganizationSubscriptionContext.Provider
            value={{
                state,
                dispatch
            }}>
            { children }
        </OrganizationSubscriptionContext.Provider>
    )
}

export default OrganizationSubscriptionProvider;